import { useEffect, useRef, useState } from "react"
import Job from "../models/Job"
import FlexRow from "../../../../components/base/FlexRow"
import { openCloseJob, openInvalidCloseJob, useHub, useSocket, closeJobQuickView, useChatList, openCopyJob, useJob, hasRole, canCloseJob, isActiveJobDenied, getUser, useGlobal, useScreen, useFlags, useTags, openAttachmentsJob, usePhone, openBrowserPhone, useHasMaskedJobCalls } from '../../../../core/Global';
import DataItem from "../../../../models/DataItem"
import Icon from "../../../../components/base/Icon"
import IconButton from "../../../../components/base/IconButton"
import CallsList from "../../../../components/calls/CallsList"
import JobChat from "./JobChat"
import JobLogsContainer from "./JobLogsContainer"
import JobDrawerEdit from "./JobDrawerEdit"
import { API_ROUTES } from "../../../../core/Constants"
import JobDrawerNotes from "./jobdrawer/JobDrawerNotes"
import { useNavigate } from "react-router-dom"
import DropdownMenu from "../../../../components/menu/DropdownMenu"
import { copyToClipboard } from "../../../../core/Helper";
import Indicator from "../../../../components/base/Indicator";
import { UserTypes } from "../../../../core/Enums";
import { Drawer } from "../../../../components/drawers/Drawer";
import { BottomSheet } from "../../../../components/base/BottomSheet";
import ActionSheet from "../../../../components/base/ActionSheet";
import { MenuItem } from "../../../../components/menu/DropdownMenu";
import ChatBox from "../../../chat/components/ChatBox";
import { usePWAStatus } from "../../../../hooks/usePWAStatus";
import ChatContactItem from "../../../chat/models/ChatContactItem";
import { isNativeApp } from "../../../../NativeAppBrdige";
import JobColorPicker from "./JobColorPicker";
import { canPaintJob, jobColorOf } from "./JobColor";

interface IProps {
    id: string
    tab: string
    onClose: () => void
}

export default function JobDrawerView(props: IProps) {


    const hub = useHub()
    // Whether there is a proxy number to hand out at all.
    const maskedAllowed = useHasMaskedJobCalls()
    const socket = useSocket()
    const navigate = useNavigate()
    const chats = useChatList()
    const user = getUser()
    const screen = useScreen()

    const tagsBank = useTags()
    const flagsBank = useFlags()

    const { isIOS, isAndroid, isStandalone } = usePWAStatus();

    const [global] = useGlobal()

    const [loading, loadingSet] = useState<boolean>(false)
    const [notfound, notfoundSet] = useState<boolean>(false)
    const [accessDenied, accessDeniedSet] = useState<boolean>(false)

    const jb = useJob(props.id)
    const [job, jobSet] = useState<Job>()

    // A technician must only ever open their own job. If the job has been reassigned to
    // someone else, deny access in the drawer instead of revealing it. Without ListActiveJobs
    // an active job is denied too, wherever the drawer was opened from.
    useEffect(() => {
        accessDeniedSet(!!job && ((!!user?.isTech && job.techId !== user.id) || isActiveJobDenied(job)))
    }, [job, user])


    const fetch = () => {

        notfoundSet(false)
        loadingSet(true)

        hub.Get(API_ROUTES.Jobs + props.id, res => {
            if (res.success) {
                jobSet(res.data)
                loadingSet(false)
            }
            else {
                loadingSet(false)
                notfoundSet(true)
            }
        })

    }

    useEffect(() => {
        if (notfound) {
            setTimeout(() => {
                //window.closeJobDrawer(() => closeJobQuickView())
            }, 1000);
        }
    }, [notfound])


    useEffect(() => {
        if (jb && !jb.isClosed) jobSet(jb)
        else fetch()
    }, [jb])



    const [Tabs] = useState<DataItem[]>([
        {
            id: "1",
            name: "Job"
        },
        {
            id: "2",
            name: "Notes"
        },
        // {
        //     id: "3",
        //     name: "Tasks"
        // },
        {
            id: "4",
            name: "Chat"
        },
        {
            id: "5",
            name: "Calls"
        },
        {
            id: "99",
            name: "Logs"
        }
    ])



    const [selectedTab, selectedTabSet] = useState<string>(props.tab)

    const [boxHeight, boxHeightSet] = useState<number>()
    const setHeight = () => {
        var h = $(window).height() ?? 400;
        h = h - ($("#kt_drawer_job_header").outerHeight() ?? 0);
        h = h - ($("#kt_drawer_job_tabs").outerHeight() ?? 0);
        boxHeightSet(h)
    }


    useEffect(() => {

        setHeight()
        window.addEventListener("resize", setHeight);

        return () => {
            window.removeEventListener("resize", setHeight);
        }
    }, [])

    useEffect(() => {
        if (job) {

            var socketKey = socket.start(
                skt => {

                    if (job.isArchived) {
                        skt.on("ArchiveJobUpdated-" + job.id, data => {
                            jobSet(data)
                        });
                    }

                    skt.invoke("StartListenToJobCalls", job.id)
                        .then(() => {
                            skt.on("PingJobCalls-" + job.id, () => {
                                refreshCallsSet(true);
                            });
                        });
                }, skt => {
                    skt.off("ArchiveJobUpdated-" + job.id)
                    skt.invoke("StopListenToJobCalls", job.id)
                        .then(() => {
                            skt.off("PingJobCalls-" + job.id);
                        });
                })
            return () => {
                socket.stop(socketKey);
            }
        }
    }, [job])

    useEffect(() => {
        if (job) {
            window.dataTableMenu()
        }
    }, [job])


    const HasUnreadChat = () => {
        var res = false;
        chats?.forEach(c => {
            if (c.tech?.id && job?.techId && c.tech.id == job.techId && c.unreadCount && c.unreadCount > 0) {
                res = true;
                return;
            }
        })
        return res;
    }

    const HasChat = () => {
        var res = false;
        chats?.forEach(c => {
            if (c.tech?.id && job?.techId && c.tech.id == job.techId) {
                res = true;
                return;
            }
        })
        return res;
    }

    const [refreshCalls, refreshCallsSet] = useState<boolean>(false)
    useEffect(() => {
        if (refreshCalls) {
            setTimeout(() => {
                refreshCallsSet(false);
            }, 500);
        }
    }, [refreshCalls])


    const [proxyLineRaw, proxyLineRawSet] = useState<string>()
    const [callLink, callLinkSet] = useState<string>()
    const [mapLink, mapLinkSet] = useState<string>()

    const [jobChat, jobChatSet] = useState<boolean>(false)
    const [jobChatTab, jobChatTabSet] = useState<"client" | "station">("station")
    const [clientChat, clientChatSet] = useState<ChatContactItem>()

    // Mobile: the header icon toolbar collapses into a single ⋮ button that opens
    // this iOS-style action sheet, listing every action as a flat, tappable row.
    const [actionsSheet, actionsSheetSet] = useState<boolean>(false)

    useEffect(() => {
        if (job) {
            hub.Get(API_ROUTES.Jobs + "sendsettings/" + job.id, res => {
                proxyLineRawSet(res.data.proxyLineRaw);
            })

            hub.Get(API_ROUTES.Chat + "getchatbyclient/" + job.id, res => {
                if (res.success && res.data) {
                    clientChatSet(res.data)
                }
            })
        }
    }, [job])

    useEffect(() => {
        if (job) {
            if (job.ignoreNotCalledText?.toLowerCase().includes("direct")) {
                callLinkSet(`${job.phoneRaw}${window.isNullOrEmpty(job.phone?.extension) ? "" : " , " + job.phone?.extension}`)
            }
            else {
                callLinkSet(`${proxyLineRaw},${job.sentPasscode}`)
            }
        }
    }, [job, proxyLineRaw])


    const phone = usePhone()

    // Open the browser phone and place a call. If a SIP line is registered &
    // connected we dial `number` directly and (optionally) send `ext` as DTMF
    // once the call is established. If no line is registered we still open the
    // phone so the user notices the phone exists / that they haven't registered.
    const dialWith = async (number?: string, ext?: string | number) => {
        openBrowserPhone();
        if (!number) return;

        const line = phone.getLines()?.find(l => l.registrationStatus === "registered" && l.transportConnected);
        if (!line) return; // not registered → just opened the phone

        const callId = await phone.dial(number, line.id);

        const postDial = `${ext ?? ""}`.replace(/[^\d#*A-Da-d]/g, "").toUpperCase();
        if (!postDial) return;

        const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        const startedAt = Date.now();
        while (Date.now() - startedAt < 20000) {
            const call = phone.getCall(callId);
            if (!call) return;
            if (call.status === "established") {
                // Small settle delay so the proxy doesn't drop the call, but short
                // enough that the digits land during the IVR's leading pause —
                // before the "Please enter the extension" prompt is ever spoken.
                await delay(800);
                for (const ch of postDial) {
                    const current = phone.getCall(callId);
                    if (!current || current.status === "ended" || current.status === "failed") return;
                    try { await phone.sendDtmf(callId, ch); } catch { }
                    await delay(200);
                }
                return;
            }
            if (call.status === "ended" || call.status === "failed") return;
            await delay(200);
        }
    }


    useEffect(() => {
        if (job?.address?.position?.lat && job.address?.position.lng) {
            if (isNativeApp()) mapLinkSet(`rinvox://navigate?lat=${job.address.position.lat}&lng=${job.address.position.lng}`)
            else if (isStandalone && isIOS) mapLinkSet(`maps://?daddr=${job.address.position.lat},${job.address.position.lng}&dirflg=d`)
            else mapLinkSet(`https://www.google.com/maps/dir/?api=1&destination=${job.address.position.lat},${job.address.position.lng}&travelmode=driving`)
        }
        else mapLinkSet(undefined)
    }, [job])


    // Flattened action list for the mobile action sheet. Mirrors exactly the actions that
    // the desktop header toolbar exposes (call/close/copy/view for admin; call/chat/navigate
    // for tech), with each dropdown expanded into its own row.
    const buildMobileActions = (): MenuItem[] => {

        const isClosed = job?.isClosed
        const isCanceled = job?.isCanceled

        // Mobile has no browser phone, so calls hand off to the device dialer via a `tel:`
        // link. The extension (if any) is appended after a comma so the dialer pauses then
        // sends the digits, matching the desktop browser-phone flow.
        const telHref = (number?: string, ext?: string | number) => {
            if (!number) return undefined
            const e = `${ext ?? ""}`.trim()
            return `tel:${number}${e ? "," + e : ""}`
        }
        const dialNative = (number?: string, ext?: string | number) => {
            const href = telHref(number, ext)
            if (href) window.location.href = href
        }

        if (user?.isTech) {
            return [
                {
                    title: "Job Attachments",
                    icon: "paperclip",
                    iconType: "regular",
                    visible: hasRole("TechJobAttachments"),
                    action: () => { if (job) openAttachmentsJob(job) },
                },
                {
                    title: "Call Customer",
                    icon: "phone",
                    iconType: "regular",
                    visible: !!job?.techAccepted && !isClosed && !isCanceled && !!callLink,
                    action: () => { window.location.href = `tel:${callLink}` },
                },
                {
                    title: "Chat",
                    icon: "message-lines",
                    iconType: "regular",
                    visible: !!job?.techAccepted,
                    action: () => jobChatSet(true),
                },
                {
                    title: "Navigate",
                    icon: "location-arrow",
                    iconType: "regular",
                    visible: !!job?.techAccepted && !!mapLink && !isClosed && !isCanceled,
                    redirect: mapLink,
                },
            ]
        }

        return [
            {
                title: "Job Attachments",
                icon: "paperclip",
                iconType: "regular",
                action: () => { if (job) openAttachmentsJob(job) },
            },
            {
                title: "Call Customer",
                icon: "phone-arrow-up-right",
                action: () => dialNative(job?.phoneRaw, job?.phone?.extension),
            },
            {
                title: "Call Secondary Number",
                icon: "phone-arrow-up-right",
                visible: !!job?.phoneContact?.phone,
                action: () => dialNative(job?.phoneContact?.phoneFriendly, job?.phoneContact?.extension),
            },
            {
                title: "Call with Extension",
                icon: "phone-office",
                visible: !!(proxyLineRaw && job?.sentPasscode) && maskedAllowed,
                action: () => dialNative(proxyLineRaw, job?.sentPasscode),
            },
            {
                title: "Call Secondary with Extension",
                icon: "phone-office",
                visible: !!(proxyLineRaw && job?.secondarySentPasscode) && maskedAllowed,
                action: () => dialNative(proxyLineRaw, job?.secondarySentPasscode),
            },
            {
                title: "Close Job",
                icon: "box-archive",
                visible: canCloseJob() && !isClosed && !isCanceled,
                action: () => {
                    hub.Get(API_ROUTES.Jobs + "validateclosing/" + job?.id, res => {
                        if (job) {
                            if (res.data) openCloseJob(job)
                            else openInvalidCloseJob(job, res.message)
                        }
                    })
                },
            },
            {
                title: "Copy with Direct Number",
                icon: "phone-arrow-down-left",
                async click(e) {
                    e.preventDefault();
                    var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + job?.id + "/?directNumber=True")
                    var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                    if (!copy && job) openCopyJob(job);
                },
            },
            {
                title: "Copy with Extension",
                visible: maskedAllowed,
                icon: "phone-office",
                async click(e) {
                    e.preventDefault();
                    var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + job?.id + "/?directNumber=False")
                    var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                    if (!copy && job) openCopyJob(job);
                },
            },
        ]
    }


    const TitleComponent = () => {


        useEffect(() => {
            window.dataTableMenu()
        }, [])

        return (
            <FlexRow visible={!user?.isTech} wrap className="gap-1 mt-1">

                {
                    (job?.payment?.paid || job?.paid) &&
                    <span className="badge badge-success" style={{ fontSize: 11 }}>
                        <Icon icon="check" size={10} type="solid" className="me-1" />
                        Paid by Rinvox
                    </span>
                }

                {
                    job?.flags?.map((item, k) =>
                        <span key={k} className="badge badge-secondary"
                            title={item.name}
                            style={{
                                fontSize: 11,
                                backgroundColor: item.color,
                                color: "#fff"
                            }}>
                            <span className="limited-text" style={{ maxWidth: 100 }}>
                                {item.name}
                            </span>
                            {
                                (!job?.isArchived || hasRole("EditArchivedJobs")) &&
                                <a href="#" className="ps-2" title="Remove Tag"
                                    onClick={e => {
                                        e.preventDefault();
                                        hub.Post(API_ROUTES.Jobs + "removeflag", {
                                            jobId: job.id,
                                            flagId: item.id
                                        }, res => { })
                                    }}>
                                    <Icon icon="times" className="text-white fs-8" />
                                </a>
                            }
                        </span>
                    )
                }

                {
                    (!job?.isArchived || hasRole("EditArchivedJobs")) && flagsBank.filter(f => !job?.flagIds?.includes(f.id)).length > 0 && ((job?.flags?.length ?? 0) < 3) &&
                    <div>
                        <a href="#" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start"
                            className="badge badge-secondary">
                            <Icon icon="plus" size={10} />
                            {
                                (job?.flags?.length ?? 0) == 0 &&
                                <span className="ms-1 fs-9 fw-bold">
                                    Add Flag
                                </span>
                            }
                        </a>
                        <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px p-0 m-0" data-kt-menu="true">
                            <div className="scroll-y noscrollbar" style={{
                                maxHeight: 300
                            }}>
                                {
                                    flagsBank.filter(f => !job?.flagIds?.includes(f.id)).map((f, k) =>
                                        <div key={k} className="menu-item m-0">
                                            <a href="#" className="menu-link px-3"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    hub.Post(API_ROUTES.Jobs + "addflag", {
                                                        jobId: job?.id,
                                                        flagId: f.id
                                                    }, res => { })
                                                }}
                                            >
                                                <Icon icon="flag" className="me-2" type="solid" color={f.color} />
                                                {f.name}
                                            </a>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                }


            </FlexRow>
        )
    }

    // The band across the drawer's top edge: it shows the job's colour and, for anyone allowed to
    // change it, is itself the control that opens the palette. This replaced the droplet icon —
    // the colour is the drawer's own edge, so that's what you click.
    const AccentComponent = () => {

        if (!job) return <></>

        if (canPaintJob(job, user?.isTech, hasRole("EditArchivedJobs")))
            return <JobColorPicker job={job} variant="bar" />

        const color = jobColorOf(job, user?.isTech)
        return color
            ? <span className="color-selector-bar is-static" style={{ backgroundColor: color }} />
            : <></>
    }

    const ToolbarComponent = () => {

        // Mobile: collapse the whole icon toolbar into a single ⋮ button that opens the
        // iOS-style action sheet. Only render it when there is at least one action.
        if (screen.isMobile) {
            const hasActions = buildMobileActions().some(a => a.visible == undefined || a.visible)
            if (!hasActions) return <></>
            return (
                <IconButton icon="ellipsis-vertical" type="regular" size={22} gap={20}
                    title="Actions"
                    onClick={() => actionsSheetSet(true)} />
            )
        }

        // Desktop: technicians have no header actions; admins/dispatchers keep the icon row.
        return (
            <>
                {
                    !user?.isTech &&
                    <>
                        <div>
                            <button type="button" title="Call"
                                data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                className={"btn btn-sm btn-white btn-icon"}
                                style={{
                                    borderRadius: "50%",
                                    width: 38,
                                    height: 38
                                }}>
                                <Icon icon="phone-volume" type="regular" size={18} />
                            </button>
                            <DropdownMenu width={240}
                                source={[
                                    // Direct calls first (primary then secondary)...
                                    {
                                        title: "Call Customer",
                                        icon: "phone-arrow-up-right",
                                        async click(e) {
                                            e.preventDefault();
                                            await dialWith(job?.phoneRaw, job?.phone?.extension);
                                        },
                                    },
                                    {
                                        title: "Call Secondary Number",
                                        icon: "phone-arrow-up-right",
                                        visible: !!job?.phoneContact?.phone,
                                        async click(e) {
                                            e.preventDefault();
                                            await dialWith(job?.phoneContact?.phoneFriendly, job?.phoneContact?.extension);
                                        },
                                    },
                                    // ...then the extension (proxy) calls grouped together.
                                    {
                                        title: "Call with Extension",
                                        icon: "phone-office",
                                        visible: !!(proxyLineRaw && job?.sentPasscode) && maskedAllowed,
                                        async click(e) {
                                            e.preventDefault();
                                            await dialWith(proxyLineRaw, job?.sentPasscode);
                                        },
                                    },
                                    {
                                        title: "Call Secondary with Extension",
                                        icon: "phone-office",
                                        visible: !!(proxyLineRaw && job?.secondarySentPasscode) && maskedAllowed,
                                        async click(e) {
                                            e.preventDefault();
                                            await dialWith(proxyLineRaw, job?.secondarySentPasscode);
                                        },
                                    }
                                ]} />
                        </div>

                        {
                            canCloseJob() && !job?.isClosed && !job?.isCanceled &&
                            <IconButton icon="box-archive" size={18} gap={20} title="Close Job" type="regular"
                                onClick={e => {
                                    hub.Get(API_ROUTES.Jobs + "validateclosing/" + job?.id, res => {
                                        if (job) {
                                            if (res.data) {
                                                openCloseJob(job)
                                            }
                                            else {
                                                openInvalidCloseJob(job, res.message)
                                            }
                                        }
                                    })
                                }} />
                        }
                        <div>
                            <button type="button" title="Copy Job"
                                data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                className={"btn btn-sm btn-white btn-icon"}
                                style={{
                                    borderRadius: "50%",
                                    width: 38,
                                    height: 38
                                }}>
                                <Icon icon="copy" type="regular" size={18} />
                            </button>
                            <DropdownMenu width={200}
                                source={[
                                    {
                                        title: "Copy with Direct Number",
                                        icon: "phone-arrow-down-left",
                                        async click(e) {
                                            e.preventDefault();
                                            var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + job?.id + "/?directNumber=True")
                                            var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                                            if (!copy && job) openCopyJob(job);
                                        },
                                    },
                                    {
                                        title: "Copy with Extension",
                                        visible: maskedAllowed,
                                        icon: "phone-office",
                                        async click(e) {
                                            e.preventDefault();
                                            var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + job?.id + "/?directNumber=False")
                                            var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                                            if (!copy && job) openCopyJob(job);
                                        }
                                    }
                                ]} />
                        </div>

                        <IconButton icon="arrow-up-right-from-square" size={18} gap={20}
                            title="View Job Details" type="regular" href={`/crm/jobs/overview/${job?.id}`} />
                    </>
                }
            </>
        )
    }



    return (
        <>
            <Drawer id="drawer-job-quickview"
                noPadding noScroll
                width="700px"
                stackReveal
                accentColor={jobColorOf(job, user?.isTech)}
                accentComponent={AccentComponent}
                onClose={props.onClose}
                title={`#${job?.jobId}`}
                titleComponent={TitleComponent}
                titleComponentBelow
                toolbarComponent={ToolbarComponent}>


                {
                    loading ?
                        <div className="mt-20 text-center w-100">
                            <Indicator />
                        </div>
                        : accessDenied ?
                            <div className="mt-20 text-center w-100">
                                <div className="mb-5">
                                    <Icon icon="lock" size={46} type="thin" className="text-danger" />
                                </div>
                                <div className="fs-4 ">
                                    You don't have access to this job!
                                </div>
                            </div>
                        : notfound ?
                            <div className="mt-20 text-center w-100">
                                <div className="mb-5">
                                    <Icon icon="exclamation-triangle" size={46} type="thin" className="text-warning" />
                                </div>
                                <div className="fs-4 ">
                                    Job not found!
                                </div>
                            </div>
                            :
                            <>
                                {
                                    user?.userType != UserTypes.Technician &&

                                    <ul id="kt_drawer_job_tabs" className="nav nav-tabs nav-line-tabs fs-6 ps-5 mb-1">
                                        {
                                            Tabs.map((t, k) =>
                                                <li key={k} className="nav-item">
                                                    <a href="#" className={`nav-link m-0 px-3 fw-bolder me-3 ${selectedTab == t.id ? "active" : ""}`}
                                                        onClick={e => {
                                                            e.preventDefault()
                                                            selectedTabSet(t.id!)
                                                        }}>
                                                        <FlexRow>
                                                            <span>{t.name}</span>

                                                            {
                                                                t.id == "2" &&
                                                                <>
                                                                    {
                                                                        job?.unseenNotes ?
                                                                            <Icon icon="circle" type="solid" className="ms-1 mb-2 text-danger" size={7} />
                                                                            : job?.notesCount && job.notesCount > 0 ?
                                                                                <Icon icon="circle" type="solid" className="ms-1 mb-2 text-primary" size={5} />
                                                                                : <></>
                                                                    }
                                                                </>
                                                            }
                                                            {
                                                                t.id == "4" &&
                                                                <>
                                                                    {
                                                                        HasUnreadChat() ?
                                                                            <Icon icon="circle" type="solid" className="ms-1 mb-2 text-danger" size={7} />
                                                                            : HasChat() ?
                                                                                <Icon icon="circle" type="solid" className="ms-1 mb-2 text-primary" size={5} />
                                                                                : <></>
                                                                    }
                                                                </>
                                                            }
                                                            {
                                                                t.id == "5" &&
                                                                <>
                                                                    {
                                                                        job?.jobCalls && job.jobCalls.length > 0 && job.jobCalls.filter(f => f.isCompleted && (f.listeners?.length ?? 0) < 1).length > 0 ?
                                                                            <Icon icon="circle" type="solid" className="ms-1 mb-2 text-danger" size={7} />
                                                                            : job?.jobCalls && job.jobCalls.length > 0 ?
                                                                                <Icon icon="circle" type="solid" className="ms-1 mb-2 text-primary" size={5} />
                                                                                : <></>
                                                                    }
                                                                </>
                                                            }
                                                        </FlexRow>
                                                    </a>
                                                </li>
                                            )
                                        }

                                    </ul>

                                }

                                {
                                    selectedTab == "1" && job && <JobDrawerEdit job={job} height={boxHeight}
                                        onWriteNote={() => selectedTabSet("2")}
                                        callLink={callLink}
                                        mapLink={mapLink}
                                    />
                                }

                                {
                                    selectedTab == "2" && job && <JobDrawerNotes job={job} />
                                }

                                {
                                    selectedTab == "4" && job && <JobChat job={job} />
                                }

                                {
                                    selectedTab == "5" && job &&
                                    <div className="scroll-y" style={{ height: boxHeight }}>
                                        <CallsList jobId={job.id} refresh={refreshCalls} noFilter noHeader compact isChild noMultipleAction />
                                    </div>
                                }

                                {
                                    selectedTab == "99" && job &&
                                    <JobLogsContainer id="job-drawer-logs" className="p-5" jobId={job?.id} height={boxHeight} jobTimezoneOffset={job.timezoneOffset} />
                                }
                            </>
                }



            </Drawer>

            {
                jobChat &&
                <BottomSheet id="bottom-sheet-chat" open
                    onClose={() => jobChatSet(false)}>

                    <div style={{
                        height: screen.height
                    }}>

                        <ul className="nav nav-tabs nav-line-tabs fs-6 ps-5 mb-1">
                            <li className="nav-item">
                                <a href="#" className={`nav-link fw-bolder fs-7 m-0 px-3 me-3 ${jobChatTab == "station" ? "active" : ""}`}
                                    onClick={e => {
                                        e.preventDefault();
                                        jobChatTabSet("station");
                                    }}>
                                    <Icon icon="user-headset" className="fs-7 me-2" type="solid" />
                                    Station
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className={`nav-link fw-bolder fs-7 m-0 px-3 me-3 ${jobChatTab == "client" ? "active" : ""}`}
                                    onClick={e => {
                                        e.preventDefault();
                                        jobChatTabSet("client");
                                    }}>
                                    <Icon icon="user" className="fs-7 me-2" type="solid" />
                                    Client
                                </a>
                            </li>
                        </ul>

                        {
                            jobChatTab === "client" ?
                                <ChatBox key={`job-${job?.id}-client-chat`}
                                    chat={clientChat}
                                    chatId={clientChat?.id}
                                    clientChatJobId={job?.id}
                                    parentId="bottom-sheet-chat"
                                    inBottomsheet
                                    onMessageSent={ch => {
                                        if (clientChat) return;
                                        clientChatSet(ch);
                                    }}
                                />
                                :
                                <ChatBox key={`job-${job?.id}-station-chat`}
                                    chat={global.techChat}
                                    chatId={global.techChat?.id}
                                    jobId={job?.id}
                                    parentId="bottom-sheet-chat"
                                    inBottomsheet />
                        }

                    </div>

                </BottomSheet>
            }

            <ActionSheet id="job-actions-sheet"
                open={actionsSheet}
                onClose={() => actionsSheetSet(false)}
                title={`#${job?.jobId}`}
                subtitle={job?.fullName}
                source={buildMobileActions()} />


        </>
    )
}